import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Flex from "../components/Flex";
import Button from "../components/Button";
import Email_img from "../../assets/svg/email_verification.svg"
import {useLocation, useHistory} from "react-router-dom";
import axios from "axios";
import {FetchResponse} from "../../utils/types";
import {API_ENDPOINT} from "../../utils/constants";

function EmailVerification2() {
    const location = useLocation<any>();
    const history = useHistory()
    const [alertStyle, setAlertStyle] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [messages, setMessages] = useState<any>({type: "", message: ""});
    const initialEmail = location.state?.emailId;
    const name = location.state?.name;
    const password = location.state?.password;
    const urlSearchParams = new URLSearchParams(history.location.search);

    const redirectUrl = urlSearchParams.get('redirect_to');
    const currentEmail = useMemo(() => initialEmail || "", [initialEmail]);
    const [email, setEmail] = useState<string>(currentEmail);
    const [newEmail, setNewEmail] = useState<string>("");
    const [isSending, setIsSending] = useState<boolean>(false);
    const [isUpdating, setIsUpdating] = useState<boolean>(false);
    const [isSkipping, setIsSkipping] = useState<boolean>(false);

    useEffect(() => {
        // Keep local email in sync with navigation state
        if (currentEmail) {
            setEmail(currentEmail);
        }
    }, [currentEmail]);

    const sendVerificationEmail = async () => {
        if (!email) return;
        setIsSending(true);
        let url = API_ENDPOINT + '/request-verification-email';
        if (redirectUrl) {
          url += `?redirect_to=${encodeURIComponent(redirectUrl)}`
        }
        try {
            const resp = await axios.post<FetchResponse<{ message: string }>>(url, { email });
            if (resp?.data?.success) {
                setMessages({
                    type: 'success',
                    message: `${resp?.data?.message}` || `${resp?.data?.data?.message}` || "Verification email sent.",
                });
            } else {
                setMessages({
                    type: 'error',
                    message: `${resp?.data?.message}` || `${resp?.data?.data?.message}` || "Unable to send verification email.",
                });
            }
        } catch (err: any) {
            setMessages({
                type: 'error',
                message: err?.response?.data?.message || err?.response?.data?.error?.[0]?.form_level_error || "Unable to send verification email.",
            });
        } finally {
            setIsSending(false);
        }
    };

    const updateEmail = async () => {
        if (!email || !newEmail) return;
        setIsUpdating(true);
        try {
            const resp = await axios.put<FetchResponse<{ message: string; email: string }>>(
                API_ENDPOINT + "/update-email",
                { old_email: email, new_email: newEmail }
            );
            const updated = (resp as any)?.data?.data?.email || newEmail;
            setEmail(updated);
            setNewEmail("");
            setMessages({
                type: "success",
                message: (resp as any)?.data?.data?.message || "Email updated successfully.",
            });
        } catch (err: any) {
            setMessages({
                type: "error",
                message: err?.response?.data?.message || err?.response?.data?.error?.[0]?.form_level_error || "Unable to update email.",
            });
        } finally {
            setIsUpdating(false);
        }
    };

    const skipForNow = async () => {
        if (!email) return;
        setIsSkipping(true);
        try {
            const resp = await axios.post<FetchResponse<{ refresh_token?: string }>>(
                API_ENDPOINT + "/skip-email-verification",
                { email, password: password || undefined }
            );
            if (!(resp as any)?.data?.success) {
                throw new Error((resp as any)?.data?.message || "Skip failed");
            }

            // Redirect to app after skip (user should be logged in now)
            if (redirectUrl) {
                try {
                    const redirectTo = new URL(redirectUrl, window.location.origin);
                    window.location.href = redirectTo.href;
                } catch (e) {
                    window.location.href = "/";
                }
            } else {
                window.location.href = "/";
            }
        } catch (err: any) {
            setMessages({
                type: "error",
                message: err?.response?.data?.message || err?.response?.data?.error?.[0]?.form_level_error || "Unable to skip verification.",
            });
        } finally {
            setIsSkipping(false);
        }
    };

    useEffect(() => {
        messages.message ? setShowAlert(true) : setShowAlert(false);
    }, [messages]);

    useEffect(() => {
        messages?.type === "success" ? setAlertStyle(true) : setAlertStyle(false);
    }, [messages]);

    return (
        <RightBanner>
            <Text>Hey{name ? `, ${name}` : ""} </Text>
            <Heading>Verify your Email</Heading>
            <Text style={{marginBottom:"30px"}}>
                You are few steps away from your unlocking your dream career
            </Text>

            {showAlert && (
                <div
                    className={
                        alertStyle ? "alert alert-success " : "alert alert-danger"
                    }
                    role="alert"
                >
                    {messages?.message}
                </div>
            )}

            <StyleDiv>
                <ImageContainer>
                    <StyleImage src={Email_img}/>
                </ImageContainer>
            </StyleDiv>
            <Text2>
                Use the button below to send a verification link to <Span>{email}</Span>.
                If not received,
                <span style={{color: "#3C4E59"}}>
                    please check your spam or bulk folder.</span>
            </Text2>
            <div style={{ marginTop: "24px" }}>
                <StyledButton onClick={sendVerificationEmail} disabled={!email || isSending}>
                    {isSending ? "SENDING..." : "SEND VERIFICATION EMAIL"}
                </StyledButton>
            </div>

            <Section style={{ marginTop: "24px" }}>
                <Text style={{ marginBottom: "10px" }}>Wrong email?</Text>
                <EmailRow>
                    <EmailInput
                        value={newEmail}
                        onChange={(e) => setNewEmail(e.target.value)}
                        placeholder="Enter new email address"
                    />
                    <SmallButton onClick={updateEmail} disabled={!newEmail || isUpdating}>
                        {isUpdating ? "UPDATING..." : "UPDATE"}
                    </SmallButton>
                </EmailRow>
            </Section>

            <Section style={{ marginTop: "18px" }}>
                <SkipRow>
                    <Text>Want to do this later?</Text>
                    <OtpReSend onClick={skipForNow} style={{ pointerEvents: isSkipping ? "none" : "auto" }}>
                        {isSkipping ? "SKIPPING..." : "SKIP FOR NOW"}
                    </OtpReSend>
                </SkipRow>
            </Section>
            <Foot>
                <Text>© 2022, Stride Ahead™</Text>
            </Foot>
        </RightBanner>

    )
}

export default EmailVerification2;


const OrContainer = styled(Flex)`
  width: 100%;
  margin-top:40px;
  color: #93ACBD;
  .line {  
    display: block;
    height: 2px;
    flex-grow: 1;
    background-color: #93ACBD;
  }
`;

const DividerSpan = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
`;

const RightBanner = styled.div`
  padding: 40px 100px;
  width:100%;
  @media(max-width: 576px){
    padding: 0px 0px;
  }
`;

const StyledButton = styled(Button)`
  width: 235.67px;
  height: 60px;
  background: #ffffff;
  margin-top: 0;
  padding: 15px 32px;
  border: 2px solid #3f52fd;
  border-radius: 10px;
  color: #3f52fd;
  
   @media(max-width: 576px){
    width: 140px;
    height: 50px;
  }
  
`;

const Heading = styled.h1`
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  color: #073b5f;
`;
const SubHeading = styled.h2``;

const Text = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #93acbd;
  margin: 0;
  @media(max-width: 576px){
    font-size: 12px;
  }
`;
const Text2 = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 30px;
  color: #93ACBD;
  margin: 0;
  @media(max-width: 576px){
    font-size: 12px;
    line-height: 20px;
  }
`;

const Span = styled.span`
  font-weight: 600;
  color: #101518;
  // a{
  // color: #3f52fd;
  // text-decoration:none;
  // }
`;

const Button1 = styled.button`
  
`;
const OtpReSend = styled.span`
  font-weight: 600;
  color: #3f52fd;
  cursor: pointer;
  font-size: 16px;
  margin-left:5px;
  
  @media(max-width: 576px){
    font-size: 12px;
    line-height: 25px;
    
  }
`;

const Section = styled.div`
  width: 100%;
`;

const SkipRow = styled(Flex)`
  margin-top: 10px;
`;

const EmailRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 6px;
  @media(max-width: 576px){
    flex-direction: column;
    align-items: stretch;
  }
`;

const EmailInput = styled.input`
  flex: 1;
  height: 48px;
  border: 1px solid #dfe7ee;
  border-radius: 10px;
  padding: 0 14px;
  outline: none;
  font-size: 14px;
`;

const SmallButton = styled(Button)`
  height: 48px;
  padding: 0 16px;
  border-radius: 10px;
`;

const StyleImage = styled.img`
    width:100%;
    height:100%;
`;
const ImageContainer = styled.div`
    width:313px;
    height:250px;
    margin :50px 0px;
    
    @media(max-width: 576px){
    width: 250.48px;
    height: 200px;
    
  }
    
`;
const StyleDiv = styled.div`
    display:flex;
    justify-content:center;
    width:100%;
`;

const Foot = styled.div`
   @media(min-width:576px){
   display:none;
   }
   @media(max-width:576px){
    margin-top:20px;
    text-align:center;
    display:block;
   }
   @media (min-width: 768px) and (max-width: 1024px){
    margin-top:40px;
    text-align:center;
    display:block;
  }
`;

